// extracted by mini-css-extract-plugin
export default {"callNowBtn":"ViewPromo_callNowBtn__Ae94W"};